// removed by extract-text-webpack-plugin
module.exports = {"user":"User__user___TCs-A","message":"User__message___3sS5Z","banner":"User__banner___3ZVVg","avatar":"User__avatar___C4PmZ","meta":"User__meta___xnBFl","name":"User__name___2IAlp","login":"User__login___Cb86o","licence":"User__licence___oSvg-","link":"User__link___2scwD","icon":"User__icon___25t3D","label":"User__label___3m-We"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/User/User.scss
// module id = 567
// module chunks = 0